<template>
  <div class="card border-0 shadow-sm my-4">
    <div class="card-body pb-2">
      <h4 class="text-primary">Settings</h4>
      <div class="mt-4">
        <form @submit.prevent="onSubmitUserConfiguration">

          <div class="w-25">
            <div class="mb-3">
              <label>Is login required for you?</label>
              <input
                type="checkbox"
                class="form-check-input float-end"
                v-model="reqObj.login_logout_reminder"
                oninvalid="this.setCustomValidity('Please select Goal Type')"
                oninput="this.setCustomValidity('')"
              />
            </div>
            <div class="mb-3">
              <label>Do you want reports through Email ?</label>
              <input
                type="checkbox"
                class="form-check-input float-end"
                v-model="reqObj.reports"
                oninvalid="this.setCustomValidity('Please select Goal Type')"
                oninput="this.setCustomValidity('')"
              />
            </div>

            <div class="mb-3 d-flex align-items-center justify-content-between">
              <label class="mb-0">
                Receive daily reports for selected users and projects.
              </label>

              <input
                type="checkbox"
                class="form-check-input"
                v-model="reqObj.watch_user_project"
              />
            </div>

          </div>

          <div v-if="reqObj.watch_user_project" class="row align-items-end mt-3">

            <div class="col-lg-4 col-md-4">
              <label class="form-label fw-bold">Users</label>

              <multiselect
                v-model="reqObj.selected_users"
                :options="activeUsers"
                :multiple="true"
                :custom-label="userOptionLabel"
                track-by="id"
                placeholder="Select Users"
                :close-on-select="false"
                :show-labels="false"
              />

            </div>

            <div class="col-lg-4 col-md-4">
              <label class="form-label fw-bold">Projects</label>

              <multiselect
                v-model="reqObj.selected_projects"
                :options="activeProjects"
                :multiple="true"
                :custom-label="projectOptionLabel"
                track-by="id"
                placeholder="Select Projects"
                :close-on-select="false"
                :show-labels="false"
              />

            </div>

          </div>

          <div class="text-end">
            <button type="submit" class="btn btn-primary">
              Submit
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import user from "@/ajax/user";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },

  data() {
    return {
      reqObj: {
        login_logout_reminder: "",
        reports: "",
        watch_user_project: false,
        selected_users: [],
        selected_projects: [],
      },
      user: [],
      siteLogReq: {
        site_name: "settings",
      },

      activeUsers: [],
      activeProjects: [],
      savedUserIds: [],
      savedProjectIds: [],
    };
  },

  // beforeMount(){
  //       this.getUserConfiguration();
  // },

  mounted() {
    Promise.all([
      this.getUsers(),
      this.fetchUserProjects(),
      this.getUserConfiguration(),
      this.fetchUserProjectWatchList(),
    ]).then(() => {
      this.applySavedSelections();
    });
  },

  created() {
    user.createSiteUsage(this.siteLogReq);
  },

  methods: {

    getUsers() {
      return user.getUsers().then((result) => {

        const users = result?.data?.data || [];

        this.activeUsers = users.filter((user) => user.doe === null);

      });
    },

    fetchUserProjects() {
      return user.getAllProjects().then((response) => {
        this.activeProjects = response?.data?.data || [];
      });
    },

    getUserConfiguration() {
      return user.getUserConfiguration().then((result) => {

        const data = result?.data?.data || {};

        this.reqObj.login_logout_reminder = !!data.login_logout_reminder;
        this.reqObj.reports = !!data.reports;
        this.reqObj.watch_user_project = !!data.watch_user_project;

      });
    },

    fetchUserProjectWatchList() {
      return user.getUserProjectWatchConfiguration().then((result) => {

        const data = result?.data?.data || {};

        this.savedUserIds = (data.selected_users || []).map((u) => u.id);
        this.savedProjectIds = (data.selected_projects || []).map((p) => p.id);

      });
    },

    applySavedSelections() {

      this.reqObj.selected_users = this.activeUsers.filter((user) =>
        this.savedUserIds.includes(user.id)
      );

      this.reqObj.selected_projects = this.activeProjects.filter((project) =>
        this.savedProjectIds.includes(project.id)
      );

    },

    userOptionLabel(option) {

      if (!option) return "";

      if (option.name) return option.name;

      const names = [
        option.first_name,
        option.middle_name,
        option.last_name,
      ].filter(Boolean).join(" ");

      return names || option.username || `User ${option.id}`;

    },

    projectOptionLabel(option) {

      if (!option) return "";

      return option.project_name || option.name || `Project ${option.id}`;

    },

    onSubmitUserConfiguration() {

      if (!this.reqObj.watch_user_project) {
        this.reqObj.selected_users = [];
        this.reqObj.selected_projects = [];
      }

      const mappingPayload = {
        selected_users: this.reqObj.selected_users.map((u) => ({ id: u.id })),
        selected_projects: this.reqObj.selected_projects.map((p) => ({ id: p.id })),
      };

      const promises = [
        user.updateUserConfiguration(this.reqObj)
      ];

      if (this.reqObj.watch_user_project) {
        promises.push(
          user.saveUserProjectWatchConfiguration(mappingPayload)
        );
      }

      Promise.all(promises)
        .then((responses) => {

          const success = responses.every(r => r.data.code === 200);

          if (success) {
            this.$swal(
              "Success",
              "Configurations Updated Successfully",
              "success"
            );
          } else {
            this.$swal("Error", "Failed To Update Configurations", "error");
          }

        })
        .catch(() => {
          this.$swal("Error", "Failed To Update Configurations", "error");
        });

    },
  },
};
</script>

<style scoped>
.startbuttons {
  padding: 5px 30px 5px 30px;
  margin: 10px;
  font-size: 20px;
}
.disableButton {
  opacity: 0.5;
  pointer-events: none;
}
.v-text-field {
  width: 400px;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}
</style>
